import { FaCheckCircle } from "react-icons/fa";

interface Props {
  onClick?: () => void;
}

export function Finalizado({ onClick }: Props = {}) {
  return (
    <FaCheckCircle
      style={{ color: "#10AC85", cursor: onClick ? "pointer" : "default" }}
      onClick={onClick}
    />
  );
}
